import React, { useEffect, useRef } from 'react';
import CommunitiesList from '#/features/community/list/CommunitiesList';
import { IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuButton, IonMenuToggle, IonPopover, IonTitle, IonToolbar } from '@ionic/react';
import { useParams } from 'react-router';
import styles from './TopNavBar.module.css';
import { useHeader } from '#/core/HeaderContext';
import AppHeader from '#/features/shared/AppHeader';
import { useAppSelector } from '#/store';
import { loggedInSelector, userHandleSelector } from '#/features/auth/authSelectors';
import { useBuildGeneralBrowseLink } from "#/helpers/routes";
import { useMediaQuery } from '@mantine/hooks';
import { minDesktopWidth } from '#/helpers/css';
import SharedDesktopButton from './tabs/buttons/sharedDesktop';
import TopNavBarProfile from './TopNavBarProfile';
import { chevronDownOutline } from 'ionicons/icons';

interface CommunitiesPageParams {
  actor: string;
}

const TopNavBar = () => {
  const { actor } = useParams<CommunitiesPageParams>();
  const buildGeneralBrowseLink = useBuildGeneralBrowseLink();
  const { header } = useHeader();
  const isDesktop = useMediaQuery(minDesktopWidth);
  const menuRef = useRef<HTMLIonMenuElement>(null);

  const loggedIn = useAppSelector(loggedInSelector);
  const handle = useAppSelector(userHandleSelector);
  
  useEffect(() => {
    if (isDesktop) {
      setTimeout(async () => {
        menuRef.current?.setOpen(true);
      }, 100);
    }
  }, [isDesktop]);

  const handleDropdownLink = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  

  return (
    <>
      <IonMenu
        ref={menuRef}
        contentId="main-content"
        side="start"
        swipeGesture={false}
        type="overlay"
      >
        <IonHeader>
          <IonToolbar>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <IonMenuToggle>
            {!isDesktop
              ? loggedIn
                ? (
                  <IonItem
                    className={styles.topNavUser}
                    lines="none"
                    routerLink={buildGeneralBrowseLink(
                      `/u/${handle}`
                    )}
                    detail={false}
                  >
                    Profile
                  </IonItem>
                )
                : (
                  <IonItem
                    className={styles.topNavUser}
                    lines="none"
                    routerLink={`/profile`}
                    detail={false}
                  >
                    Login/Signup
                  </IonItem>
                )
              : null
            }
            <CommunitiesList actor={actor} />          
          </IonMenuToggle>
        </IonContent>
      </IonMenu>
      
      <AppHeader className={styles.topNavWrapper}>
        <IonToolbar>
          <IonButtons slot="start" className={styles.topNavIcon}>
            <IonMenuButton></IonMenuButton>
            <div id="dropdown-trigger" className={styles.dropdownTrigger}>
              <img src="/logo.png" alt=""/>
              <IonIcon icon={chevronDownOutline} />
            </div>
            <IonPopover trigger="dropdown-trigger" triggerAction="click">
              <IonList>
                <IonItem button detail={false} onClick={() => handleDropdownLink('https://democrats.com/')}>
                  Democrats.com
                </IonItem>
                <IonItem button detail={false} onClick={() => handleDropdownLink('https://www.swipeblue.org/')}>
                  SwipeBlue
                </IonItem>
                <IonItem button detail={false} onClick={() => handleDropdownLink('https://www.act.tv/')}>
                  Act.tv
                </IonItem>
              </IonList>
            </IonPopover>
          </IonButtons>
          {isDesktop
            ? <>
            <div className={styles.topNav}>
              <SharedDesktopButton
                tab="posts"
                href="/"
              >
                <IonLabel>Democrats.com</IonLabel>
              </SharedDesktopButton>
              <SharedDesktopButton
                tab="feed"
                href="/posts/all"
              >
                <IonLabel>Feed</IonLabel>
              </SharedDesktopButton>
              <SharedDesktopButton
                tab="curators"
                href="/curators"
              >
                <IonLabel>Curators</IonLabel>
              </SharedDesktopButton>
              <SharedDesktopButton
                tab="info"
                href="/info"
              >
                <IonLabel>Info</IonLabel>
              </SharedDesktopButton>
              <SharedDesktopButton
                tab="search"
                href="/search"
              >
                <IonLabel>Search</IonLabel>
              </SharedDesktopButton>
              <SharedDesktopButton
                tab="profile"
                href="/profile"
              >
                <IonLabel>{loggedIn ? 'Profile' : 'Login'}</IonLabel>
              </SharedDesktopButton>
            </div>
            </>
            : null
          }
          {!isDesktop && header.title
            ? (
              <IonTitle>
                {header.title}
              </IonTitle>
            )
            : null
          }
          {!isDesktop
            ? header.children
            : null
          }
          
          <IonButtons slot="end" className={styles.topNavIcon}>
            <TopNavBarProfile handle={handle || ''} />
          </IonButtons>
        </IonToolbar>
      </AppHeader>
    </>
  )
}

export default TopNavBar;